module.exports = __webpack_public_path__ + "img/technology3.236bd685.png";